/**
* @ngdoc directive
* @name Orientation Change
*
* @description
  Do something on window resize
*
* @scope
* @param {Number} breakpoint
* @param {Function} callback - on resize when breakpoint is passed
*
* @example
  <div orientation-change callback="alert()" breakpoint="768"></div>
*/

(function() {

  orientationChange.$inject = ["$compile", "$window", "$timeout"];
  app.directive('orientationChange', orientationChange);

  function orientationChange($compile, $window, $timeout) {
    var directive = {
      restrict: 'A',
      link: link,
      scope: {
        breakpoint: '=',
        callback: '&'
      }
    };

    return directive;

    function link($scope) {
      var breakpoint = parseInt($scope.breakpoint);
      var shouldCallback = !breakpoint ||
        $window.innerHeight > breakpoint && $window.innerWidth <= breakpoint ||
        $window.innerHeight <= breakpoint && $window.innerWidth > breakpoint;

      if (shouldCallback) {
        window.addEventListener('resize', function() {
          $timeout($scope.callback, 20);
        });
      }
    }
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/orientationChangeDirective.js